// CreateAreascontrolcambiosPage.tsx


import { SaveAreascontrolcambios } from "../../components";


export default function CreateAreascontrolcambiosPage() {
  
  // useCheckPermissions(PermissionsEnum.api_change_areascontrolcambios);
  
  return (
    <SaveAreascontrolcambios
      titulo="Crear Areas de control de cambios"
    />
  )
}
